import { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Calendar, DateObject } from "react-multi-date-picker";
import moment from "moment";
import "moment-timezone";
import { eventUpdate } from "../../actions/loginActions";
import { baseUrl, getCookie, TOAST_ERROR, TOAST_SUCCESS } from "../../utils";
import { useCookies } from "react-cookie";
import { MediaBaseUrl, SW_LOGO_ICON } from "../../actions/api";

const EventPopup=()=> {
  const [loader, setLoader] = useState(false);
  const [erroMsg, seterroMsg] = useState(null);
  const [show, setShow] = useState(true);
  const [isRequest, setisRequest] = useState(getCookie('eventPopup')==2 ? 2 : 0);
  const [days, setDays] = useState(null);
  const [cookies, setCookie, removeCookie] = useCookies(['eventPopup']);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const datePickerRef = useRef();

  const [selectingdateRange, setselectingdateRange] = useState([
    new DateObject().subtract(0, "days"),
    new DateObject().add(0, "days"),
  ]);


  const onSubmitWallData = async (e) => { 
    
    if (!startDate) {
        if(isRequest==2)
          seterroMsg(true);
          if(isRequest==1) { 
          setisRequest(3)
          const gettimeOut = setTimeout(() =>
            { 
              updateCookie()
              clearTimeout(gettimeOut)
            }, 3000);
        }else setisRequest(2)
    }
    if(isRequest > 0){
    setLoader(true);
    try {

      const data =  {
        eventStartDate: isRequest==2 ? moment(startDate).unix() : '',
        eventEndDate: isRequest==2 ? moment(endDate).unix() : '',
        timeZone: isRequest==2 ? moment.tz.guess() : '',
        type: isRequest==2 ? 'E': "D"
        };
  
      const { data: responseData } = await eventUpdate(data);
      
      if (responseData.responseCode) {
        TOAST_SUCCESS(responseData.responseMessage);
        updateCookie()
      }else TOAST_ERROR(responseData.responseMessage);
       
    } catch (error) {
      const { data } = error.response;
      TOAST_ERROR(data.responseMessage);
    } finally {
      setLoader(false);
    }
  }
  };


  const handleChange = (newValues) => {
    const handleDate = newValues.map((date) => date.format("YYYY-MM-DD"));
    const toDate = handleDate[1] ? handleDate[1] : handleDate[0];
    setselectingdateRange(newValues);
    setStartDate(handleDate[0]);
    seterroMsg(null);
    setEndDate(toDate);
    setDays(Math.abs(moment(toDate).diff(moment(handleDate[0]), "days")) + 1);
  };

                                                                                                         
  const updateCookie = (e) => {
    setShow(false);
    (isRequest!=2 || e == 1) 
      ? setCookie('eventPopup', "0", { path: '/' }) 
      : removeCookie('eventPopup', { path: '/' });
  }



  useEffect(() => {
    if (datePickerRef.current) datePickerRef.current.openCalendar(); // Open calendar manually on mount
  }, [datePickerRef]);

  return (
    <Modal className="sw_theme custom-calandly-popup" show={show} size={`${isRequest==2 ? 'lg' : 'md'}`} aria-labelledby="contained-modal-title-vcenter" centered>
      <button type="button" className="btn btn-link calandly-close" onClick={()=> updateCookie(1)}>
        <img className="img-responsive" src={`${MediaBaseUrl}icons/svg-icons/close-white.svg`} width="28" height="28" />
      </button>
      <div className="modal-content">
        <div className="maintainPopUp" id="WallCreateForm" method="post" acceptCharset="utf-8">
          <div className="modal-body p-0">
            <div id="createWallBlock">
              <div className="panel-body">

               { isRequest==2 ? 

                <div className="row m-0">
                 <div className="col-md-6">
                    <div className="py-5 px-4 custom-calandly-left">
                      <div className="mb-3">
                        <img src={SW_LOGO_ICON} class="mb-3 img-fluid" width={"50px"} />
                        <h2 className="mb-0">Help Us Save The Dates! </h2>
                      </div>
                      <div className="event-time mb-3 pb-2">
                        <h6 className="mb-3 pb-3 border-bottom">
                          <img className="img-responsive" src={`${MediaBaseUrl}icons/svg-icons/clock.svg`} width="20" height="20" /> <strong>Event</strong></h6>
                        <p className="event-date mb-2 text-dark"> 
                           { startDate && <><strong>From : </strong> { moment(startDate).format("DD-MMM-YYYY")} </> } 
                           { endDate &&  <><strong>- To :</strong> { moment(endDate).format("DD-MMM-YYYY") } </> }
                        </p>
                        {days && <p className="event-date text-dark mb-0"><strong>Days:</strong> {days}</p>}
                      </div>
                      <p className="event-disc">
                        Tell us when you're planning your event and we'll help you make it a massive success.</p>

                        <p className="event-disc m-0"> 
                          <strong> Note: </strong> You can also add tentative dates if you aren't sure about it yet
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="calandly-calander h-100">
                      <Calendar
                        minDate={new DateObject()} // Disables all previous dates
                        calendarPosition="top" // Sets the calendar to open at the top
                        format="DD-MM-YYYY" // Sets the date format to day-month-year
                        value={selectingdateRange}
                        currentDate={null} 
                        editable={false} // Keeps the calendar fixed and disables toggle on outside clicks
                        disableDayPicker={false} // Keeps the calendar visible
                        hideOnScroll={false} // Prevents hiding on scroll events
                        className="form-control placeholder-no-fix h-100"
                        portal={false} // Prevents floating overlay behavior
                        onChange={handleChange}
                        range
                      />
                    </div>
                  </div>
                </div>

                 :

                <div className="select-goal-main p-5 text-center">
                 { isRequest==3 ? 
                  <div className="py-4">
                      <img className="mb-4" src={baseUrl('icons/svg-icons/ok.png')} height="70" width="70" />
                   <p className="font-size-h5 mb-0">Thank you for sharing your preferences!<br/>We'll tailor your experience to make it truly personalized.</p></div>  : 

                  <div className="">
                       <h6 className="fs-3 mb-3">What's your goal with Social Walls?</h6>
                        <p className="">Tell us your use case, and we'll create a tailored experience for you!</p>
                        <div className="d-flex justify-content-center flex-wrap my-5">
                        <div className="select-goal position-relative rounded me-2">
                          <input className="position-absolute w-100 h-100 start-0 cursor-pointer opacity-0" type="radio" checked={!isRequest} name="for_request" id="for_event" onClick={(e)=>setisRequest(0)} />
                           <div className="select-goal-inner">
                             <div className="d-flex px-3 py-4 justify-content-between align-items-center">
                              <span>For Event </span>
                              <label></label>
                            </div>
                          </div>
                        </div>
                        <div className="select-goal position-relative rounded">
                          <input className="position-absolute w-100 h-100 start-0 cursor-pointer opacity-0" type="radio" checked={isRequest}  name="for_request" id="for_digital_sign" onClick={(e)=>setisRequest(1)} />
                          <div className="select-goal-inner">
                            <div className="d-flex px-3 py-4 justify-content-between align-items-center">
                              <span>For Digital Signage</span>
                              <label></label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className=""> 
                      <Button variant="outline-dark" className={`me-2 btn-min-w`} onClick={()=> updateCookie(isRequest) }><span className="position-relative">Skip</span></Button>
                      <Button variant="primary" disabled={loader}  className={`${ loader ? "ladda-button spinner spinner-white spinner-right disabled " : "" } btn-min-w`} onClick={onSubmitWallData} type="button">Continue</Button>
                      </div>
                    </div>
                   } 
                 </div>
                }

              </div>
            </div>
          </div>

        { isRequest==2 ?         

          <div className="modal-footer">
            { erroMsg && <div style={{ color: "red", width: "72%", }}>Please select Event Date</div>}
          
            <button
              type="button"
              className="btn btn-secondary m-0 me-3"
              onClick={()=>updateCookie(1)}
            >
            Close
            </button>
            <button
              type="submit"
              disabled={loader}
              onClick={onSubmitWallData}
              className={`${
                loader  ? "ladda-button spinner spinner-white spinner-right disabled "
                  : ""
              } btn btn-primary m-0 me-0`}
            >
              Submit
            </button>
          </div> : null }

        </div>
      </div>
    </Modal>
  );
}

export default EventPopup;
  
